<form  [formGroup]="pipelineassetlinkForm">
  <div class="toggle_view">
    <mat-button-toggle-group
  name="fontStyle"
  aria-label="Font Style"
  color="accent"
  class="m-3"
  
  >
  <mat-button-toggle value="list" color="accent" (click)="onList()"
    ><mat-icon class="example-tab-icon"
      >list</mat-icon
    ></mat-button-toggle
  >
  <mat-button-toggle value="grid" (click)="onGrid()"
    ><mat-icon class="example-tab-icon"
      >view_module</mat-icon
    ></mat-button-toggle
  >
  </mat-button-toggle-group>
  </div>
  <div class="other_contents">
   
    <div class="contents">
      <div class="asset_tab tab_content" id="content2" data-tab="1">
        <div class="top">
          <h2 class="title">Asset Details</h2>
          <button class="default_secondary-btn" (click)="onPopUpDisplay(pipelineassets)">Add Asset Details</button>
        </div>
        
        <!-- ENTRY ENTRY ENTRY====================================ENTRY ENTRY ENTRY=====================ENTRY -->
        <div class="entry_values" formArrayName="PipelineAssetLinks" *ngIf="gridView">
          <div class="entry" *ngFor="let pipeasst of pipelineassetlinkForm.get('PipelineAssetLinks')['controls']; index as i" [formGroupName]="i">
            <h1 class="section_name">
              <em class="ti-image"></em> 
              <span class="name"><input type="text" style="border: none" name="faculty" id="Faculty" class="input"  placeholder="Land Name" formControlName="LandName"></span>
              <em class="ti-trash" (click)="onDelete(pipeasst.value, i)"></em> 
            </h1>

            <div class="location">
              <p class="other_item">Field Name: <span class="file_name"><input type="text" style="border: none" name="faculty" id="Faculty" class="input" formControlName="SubSubGroupName"></span></p>
              <p class="other_item">Location Name: <span class="location_name"><input type="text" style="border: none" name="faculty" id="Faculty" class="input" formControlName="CategoryName"></span></p>
            </div>
          </div>
          <div class="btn_holder">
            <button type="submit"  class="default_primary-button" [disabled]="control().length <=0" (click)="onSubmit(pipelineassetlinkForm.value)" type="submit">
              <ng-container>
                Save  &rarr;
              </ng-container>
            </button>
           </div>
        </div>

        <div class="card mt-3" *ngIf="listView">
          <div class="btn_holder">
            <button type="submit"  class="default_primary-button" [disabled]="control().length <=0" (click)="onSubmit(pipelineassetlinkForm.value)" type="submit">
              <ng-container>
                Save  &rarr;
              </ng-container>
            </button>
           </div>

          <table class="table table-hover" >
            <thead>
              <tr>
                <th scope="col">S/N</th>
                <th scope="col">Land Name</th>
                <th scope="col">Field Name</th>
                <th scope="col">Location Name</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody formArrayName="PipelineAssetLinks">
              <tr  *ngFor="let pipeasst of pipelineassetlinkForm.get('PipelineAssetLinks')['controls']; index as i" [formGroupName]="i"
              >
                <th scope="row">{{i + 1}}</th>
                <td><input type="text" style="border: none" name="faculty" id="Faculty" class="input" formControlName="LandName"></td>
                <td><input type="text" style="border: none" name="faculty" id="Faculty" class="input" formControlName="SubSubGroupName"></td>
                <td><input type="text" style="border: none" name="faculty" id="Faculty" class="input" formControlName="CategoryName"></td>
                <td><em class="ti-trash" (click)="onDelete(pipeasst.value, i)"></em> </td>
              </tr>
      
            </tbody>
          </table>
      
        </div>
      </div>
    </div>
    
  </div>
</form>



















<!-- <div class="reference_body">
    <main class="reference_main">
    <form  [formGroup]="pipelineassetlinkForm">
        <div class="row">
            <div class="col-md-5">
                <div class="row">
                    <div class="parameter_contained col-lg-12">
                        <label for="" style="display:block;">Land Name</label>
                        <div class="search">
                            <input type="text" name="search" id="nav_search"
                                    placeholder="Enter land name" formControlName="LandName">
                        </div>
                        <mat-error *ngIf="errorHandling('LandName', 'required')">
                            You must provide <strong>land name</strong>
                         </mat-error>
                    </div>
                </div>
                <div class="row">
                    <div class="parameter_contained col-lg-12">
                        <label for="" style="display:block;">Field Name</label>
                        <div class="search">
                            <input type="text" name="search" id="nav_search"
                                    placeholder="Enter field" formControlName="SubSubGroupName">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="parameter_contained col-lg-12">
                        <label for="" style="display:block;">Location Name</label>
                        <div class="search">
                            <input type="text" name="search" id="nav_search"
                                    placeholder="Enter location" formControlName="CategoryName">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="the_button col-lg-12">
                        <button class="next" *ngIf="selectedPipelineDetails" (click)="onSubmit(pipelineassetlinkForm.value)">Submit</button>
        
                    </div>
                    <div class="the_button col-lg-12">
                        <button class="next" *ngIf="selectedPipelineDetails" (click)="onCreate()">Create New</button>

                    </div>
                </div>
            </div>
            
            <div class="col-md-5">
                <div class="row">
                    <div class="card" *ngFor="let pipeasst of selectedPipelineDetails?.pipelineAssetLink2s; index as i">
                        <div class="card-body" (click)="onPatchValue(pipeasst)">
                            <div class="parameter_contained">
                                <label for="" style="display:block;">Land Name</label>
                                <div class="search">
                                    <label for="">
                                        <span >{{pipeasst.LandName}}</span>
                                    </label>
                                </div>
                            </div>
                            <div class="parameter_contained">
                                <label for="" style="display:block;">Field Name</label>
                                <div class="search">
                                    <label for="">
                                        <span>{{pipeasst.SubSubGroupName}}</span>
                                    </label>
                                </div>
                            </div>
                            <div class="parameter_contained">
                                <label for="" style="display:block;">Location Name</label>
                                <div class="search">
                                    <label for="">
                                        <span>{{pipeasst.CategoryName}}</span>
                                    </label>
                                </div>
                            </div>
                            <div class="the_button">
                                <button (click)="onDelete(pipeasst, i)" ><em class="ti-trash the__icons" >Delete</em> </button>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    </main>
</div> -->